// extracted by mini-css-extract-plugin
export default {"contents":"sE-z","sectionHeading":"tE-z"};